import _ from 'i18n';
import axios from 'axios';
import {NotificationManager} from 'react-notifications';
import {pushSourceToken as pushSourceTokenAction} from 'actions';
import chroma from 'chroma-js';
import queryString from 'query-string';
import { findIndex, castArray } from 'lodash';
import { Link,  browserHistory} from 'react-router';
import { TTP_HOME_URL, TTP_EMAILING_URL, AUTH_LOW_SECURITY_COOKIE_NAME } from 'Config';
import {getLocalStorageAuth, setLocalStorageAuth, setCreditNoteRedirectStorage} from 'PaymentAPI';
import {notification} from "antd";
import { BLOCKED_CLIENT_ID, FALLBACK_CLIENT_ID } from 'Common';


// Returns the client to activate: the blocked organization is replaced by the fallback one (null if the user doesn't have it).
export const getAllowedClient = (client, paymentClients = []) => {
  if (!client || client.id != BLOCKED_CLIENT_ID) {
    return client;
  }
  return (paymentClients || []).find(({ id }) => id == FALLBACK_CLIENT_ID) || null;
};

export const htmlDecode = (strData) => {
  if (undefined === strData) {
    return '';
  }

  return strData.replace(/&#(\d+);/g, (match, dec) => {
    return String.fromCharCode(dec);
  });
};

export const unescapeHtml = (safe) => {
  return safe.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, `"`).replace(/&#039;/g, `'`);
};

export const purifyString = (string) => {
  return htmlDecode(unescapeHtml(string));
};

export const generateHTMLFile = (data, filename) => {
  const blob = new Blob([data], {type: 'text/plain'});

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
    return;
  }

  const csvURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', filename);
  tempLink.setAttribute('target', '_blank');
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};

export const getDateLabel = (date) => {
  const d = new Date(date);

  const result = d.toDateString().split(' ');

  const hours = parseInt(d.getHours()) < 10 ? '0' + d.getHours() : d.getHours();
  const minutes = parseInt(d.getMinutes()) < 10 ? '0' + d.getMinutes() : d.getMinutes();

  return result[2] + ' ' + result[1] + ' ' + result[3] + ', at ' + hours + ':' + minutes;
};

export const getDateInMSecond = (stringDate) => {
  let parts = stringDate.split(' ');
  let datePart = parts[0].split('-');
  let timePart = parts[1].split(':');

  let d = new Date(datePart[0], datePart[1] - 1, datePart[2], timePart[0], timePart[1], timePart[2]);

  return d.getTime();
};

export const getUserNameForAvatar = (firstName, lastName) => {
  let fName = firstName.split(' ');

  if (fName.length >= 3) {
    return extractFirstLetter(fName, 3);
  }

  let lName = lastName.split(' ');
  return extractFirstLetter(fName.concat(lName), 3);
};

function extractFirstLetter(arrayStr, length) {
  let result = '';

  for (let i = 0; i < arrayStr.length; i++) {
    if (arrayStr[i] !== undefined) {
      result += arrayStr[i].substring(0, 1);
    }
  }

  return result.toUpperCase();
}

export function extractResourcesId(resources) {
  let ids = [];

  for (let resource of resources) {
    ids.push(resource.id);
  }

  return ids;
}

export function onSuccess(res, message = null) {
  if (!message) {
    message = {body: 'operationCompleted', title: 'successfulAction'};
  }
  if (res.value instanceof Error) {
    NotificationManager.error(_('incompleteOperation'), _('error'));
  } else {
    NotificationManager.success(_(message.body), _(message.title));
  }
}

export function onError(err) {
  NotificationManager.error(_('errorOccured'), _('error'));
}

export const EMAIL_VALIDATION_REGEX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

export const URL_REGEX = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})$/;

export function convertReplyTo(tags) {
  let replyTo = [];
  let mailPattern = new RegExp(EMAIL_VALIDATION_REGEX);

  for (let i = 0; i < tags.length; i++) {
    let matches = tags[i].match(/^(.*)<\s*(.*)\s*>$/i);
    if (matches && matches.length === 3 && mailPattern.test(matches[2])) {
      replyTo.push({'name': matches[1].trim(), 'email': matches[2].trim()});
    } else if (mailPattern.test(tags[i])) {
      replyTo.push({'email': tags[i].trim()});
    }
  }

  return JSON.stringify(replyTo);
}

export function convertToStringTag(replyTo = []) {
  let tags = [];

  for (let i = 0; i < replyTo.length; i++) {
    let tag = replyTo[i].email;
    if (replyTo[i].name) {
      tag = replyTo[i].name + ' <' + replyTo[i].email + '>';
    }
    tags.push(tag);
  }

  return tags;
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

export function setCookie(name, value, expires, path, domain, secure, escapeValue= true) {
  document.cookie = name + ' = ' + (escapeValue ? escape(value) : value) + '  ' +
    ((expires === undefined) ? '' : ('; expires = ' + expires.toGMTString())) +
    ((path === undefined) ? '' : ('; path = ' + path)) +
    ((domain === undefined) ? '' : ('; domain = ' + domain)) +
    ((secure === true) ? '; secure' : '');
}

export const modalStyle = {
  overlay: {
    zIndex: 3,
    backgroundColor: "rgba(62, 60, 60, 0.8)"
  },
  content: {
    top: '50%',
    left: '50%',
    width: "60%",
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    transition: 'opacity 0.4s ease-out 0s',
    border: 'none',
    borderRadius: 0,
    paddingBottom: 0,
    overflow: 'hidden',
  },
};

export function getSourceToken() {
  let CancelToken = axios.CancelToken;
  return CancelToken.source();
}

export function updateSourceToken(oldSourceToken, newSourceToken) {
  if (oldSourceToken) {
    oldSourceToken.cancel('Operation canceled by the user.');
  }
  return newSourceToken;
}

export function throwCatchedError(thrown) {
  if (axios.isCancel(thrown)) {
    throw {response: {status: 700}};
  }
  throw thrown;
}

export function pushSourceToken(sourceName, dispatch) {
  let sourceToken = getSourceToken();

  dispatch(pushSourceTokenAction(sourceName, sourceToken));

  return sourceToken;
}

export function getUrlParams() {
  const search = location.search.substring(1);
  if (!search) {
    return null;
  }
  return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function getRate(n, total) {
  let rate = (total == 0) ? 0 : n * 100 / total;
  return !rate ? 0 : Math.round(rate).toFixed(2);
}

export function getLanguages() {

  return [
    {key: 'en', value: 'english'},
    {key: 'fr', value: 'french'},
    {key: 'nl', value: 'dutch'},
  ];
}

export function getParents(el, parentSelector) {
  var parents = [];
  var p = el.parentNode;

  while (p !== parentSelector) {
    var o = p;
    parents.push(o);
    p = o.parentNode;
  }
  parents.push(parentSelector);

  return parents;
};

export function formatAmount(amount, isDivided = true) {
  return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(isDivided === true ? amount / 100 : amount);
};

export const urlFiltersParser = (url) => {
  const filters = [];
  const regexp = /(\w+)=(?:\[([^\][]*)]|'([^']*)'|"([^"]*)"|(\w+))/g;
  let matches = null;

  while ((matches = regexp.exec(url)) !== null) {
    let value = (matches[5] || matches[4] || matches[3] || matches[2]);
    let operator = undefined !== matches[5] || undefined !== matches[4] || undefined !== matches[3] ? "eq" : "in";

    filters.push({
      property: matches[1],
      operator: operator,
      value: 'in' === operator ? value.replace(/(['"])/g,'').split(',') : value.replace(/('|")/g,''),
    });
  }

  return filters;
};

export const updateUrlFilter = (property, operator, value) => {

  const urlParams   = queryString.parse(decodeURI(location.search)) || [];

  let params = urlFiltersParser(urlParams.filters);

  let index = findIndex(params, {'property': property});
  if(-1 !== index) {
    if(value && value.length > 0) {
      params[index].value = 'eq' === params[index].operator ? value : castArray(value);
    } else {
      delete params[index];
    }
  } else {
    if(value && value.length > 0) {
      params.push({property, operator, value});
    }
  }

  let filtersValue = [];
  params.forEach(function(item) {
    let value = 'eq' === item.operator ? `'${item.value}'` : `[${"'" + item.value.join("','") + "'"}]`;
    filtersValue.push(`${item.property}=${value}`);
  });

  if(filtersValue.length > 0) {
    urlParams.filters = '{' + filtersValue.join(',') + '}';
  } else {
    delete urlParams.filters;
  }

  const url =  location.pathname+ '?' + queryString.stringify(urlParams, {strict: false, encode: true});

  browserHistory.replace(url)

};

export const getEmailingCampaignLink = ({communityId = 0, targetId = 0, language,discriminant,rappelType, appRef, returnto, appType }) => {
  const showAppRef = appRef.length > 0 ? `appRef=[${appRef.join(',')}]` : ``;
  const target = targetId == 'EVENT' ? 'EVENT_REMINDER' : targetId;


  const campaignUrl = `${TTP_EMAILING_URL}campaign?discriminant=${discriminant}&rappelType=${rappelType}&${showAppRef}&targetId=${target}&returnto=${returnto}&appType=${appType}&communityId=${communityId}&targetApp=PAYMENT`;

  return `${campaignUrl}&language=${language}`;
};

export const PAYMENT_REMINDER_TYPES = [
  {
    discriminant: 'invoice',
    rappelType: '1',
    value: "INVOICE_RAPPEL1",
  },
  {
    discriminant: 'invoice',
    rappelType: '2',
    value: "INVOICE_RAPPEL2",
  },
  {
    discriminant: 'invoice',
    rappelType: '3',
    value: "INVOICE_RAPPEL3",
  },
  {
    discriminant: 'invoice',
    rappelType: '4',
    value: "INVOICE_RAPPEL4",
  },
  {
    discriminant: 'order',
    rappelType: '1',
    value: "BDC_RAPPEL1",
  },
  {
    discriminant: 'order',
    rappelType: '2',
    value: "BDC_RAPPEL2",
  },
  {
    discriminant: 'order',
    rappelType: '3',
    value: "BDC_RAPPEL3",
  },
  {
    discriminant: 'order',
    rappelType: '4',
    value: "BDC_RAPPEL4",
  },
  {
    discriminant: 'credit_note',
    rappelType: '1',
    value: "NDC_RAPPEL1",
  },
  {
    discriminant: 'credit_note',
    rappelType: '2',
    value: "NDC_RAPPEL2",
  },
  {
    discriminant: 'credit_note',
    rappelType: '3',
    value: "NDC_RAPPEL3",
  },
  {
    discriminant: 'credit_note',
    rappelType: '4',
    value: "NDC_RAPPEL4",
  }
];

export const resolvePaymentType = (discriminant, rappelType) => {
  if (!discriminant || !rappelType) {
    return null;
  }

  const paymentType = PAYMENT_REMINDER_TYPES.find(type => type.discriminant == discriminant && type.rappelType == rappelType)
  return paymentType ? paymentType.value : null
}

export const reactSelectStyles = () => {
  const height = 40;

  return ({
    control: (provided, state) => ({
      ...provided,
      borderRadius: "0",
      backgroundColor: "#fff",
      //height: "2.8rem",
      height: height,
      minHeight: height,
      overflow: "hidden",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "1rem",
      color: "#bbb",
      fontWeight: 300
    }),
    menuList: (base, state) => ({
      ...base,
      paddingTop: "0",
      paddingBottom: "0"
    }),
    menu: (base, state) => ({
      ...base,
      borderRadius: "0"
    }),
    option: (base, state) => ({
      ...base,
      textAlign: "left",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: "all .2s ease",
    }),
    input: (base, state) => ({
      ...base,
      height: height,
      minHeight: height,
      overflowY: "auto",
      margin: 0
    }),
    container: (base, state) => ({
      ...base,
      height: height,
      minHeight: height
    }),
    valueContainer: (base, state) => ({
      ...base,
      height: height,
      minHeight: height,
      overflowY: "auto",
      margin: 0
    }),
    group: (base, state) => ({
      ...base,
      borderBottom: '2px solid #d9d9d9'
    }),
    groupHeading: (base, state) => ({
      ...base,
      //display: 'none',
      backgroundColor: '#e6f7ff',
      color: '#000',
      textAlign: 'center',
      padding: '15px 0',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '0.75rem'
    }),
    multiValue: (base, {data}) => {
      if (data.color) {
        const color = chroma(data.color);
        return {
          ...base,
          backgroundColor: color.alpha(0.1).css(),
        };
      }

      return base;
    },
    multiValueLabel: (base, {data}) => ({
      ...base,
      color: data.color,
    }),
    multiValueRemove: (base, {data}) => ({
      ...base,
      color: data.color,
      ':hover': {
        backgroundColor: data.color,
        color: 'white',
      },
    }),
  });
};


export const setAuthCookie = ({id, firstName, lastName, mainEmail, token}) => {
  const { expires, access_token } = token;
  const dtExpireCookie = new Date();
  dtExpireCookie.setTime(+expires * 1000);

  const tokenCreatedAt = new Date();
  const tokenExpiresIn = +expires - Math.floor(tokenCreatedAt.getTime() / 1000);

  const authInfos = {
    createdAt: Math.floor(tokenCreatedAt.getTime() / 1000),
    expiresIn: tokenExpiresIn,
    email: mainEmail,
    fullName: `${firstName} ${lastName}`,
    id,
    token: access_token,
  };

  setCookie(
    AUTH_LOW_SECURITY_COOKIE_NAME,
    encodeURIComponent(JSON.stringify(authInfos)),
    dtExpireCookie,
    '/',
    'tamtam.pro',
    false,
    false,
  );
};

export const getAuthInfos = (cookieName) => {

  const userCookie = getCookie(cookieName);
  const now = Math.floor(new Date().getTime() / 1000);

  if (userCookie && userCookie.length > 0) {
    const authInfos = JSON.parse(userCookie);
    if (authInfos && typeof authInfos === 'object') {
      return {authInfos  , expired : isTTPTokenExpired(authInfos)}
    }
  }
  return {authInfos : null , expired : true}
}


export const isTTPTokenExpired = (token) => {
  if (!token) return true;

  const { createdAt = NaN, expiresIn = NaN, expiry = NaN } = token;

  if (isNaN(+createdAt) || isNaN(+expiresIn)) {
    return true;
  }

  const now = Date.now();

  if (!isNaN(+expiry)) {
    const expiryMs = +expiry * 1000;
    return now >= expiryMs;
  }

  const createdAtMs = +createdAt * 1000;
  const expiresInMs = +expiresIn * 1000;

  return now >= createdAtMs + expiresInMs;
};

export const mangopayContactStyle = () => {
  return({
  menu: styles => ({ ...styles, top:'auto', bottom:'100%', fontSize:'14px', color:'#29394d',background:'#f3faff', }),
  control: styles => ({
    ...styles,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    backgroundColor:'#f3faff',
    borderRadius: '3px',
    border: '1px solid #c7e8fe',
  }),
  input: styles => ({
    ...styles,
    fontSize:'14px',
    color:'#29394d',
    height:'35px'
  }),})};


export const actionsSettingsStyle = () => {
  return({
    menu: styles => ({ ...styles, color:'#29394d', zIndex: 3,}),
    input: styles => ({
      ...styles,
      fontSize:'14px',
      color:'#29394d',
      height:'40px',
      width: '0px',
      boxShadow:'none',
      border:'none'
    }),
    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: isFocused || hasValue ? 'white':'#F8F9FA',
      border: isFocused || hasValue ? '1px solid #18A0FB' : '1px solid #B2BCC6',
      boxSizing: 'border-box',
      borderRadius: '3px',
      height:'40px',
      color:'#29394d',
      fontSize:'14px',
      boxShadow: 'none',
    }),
    placeholder: styles => ({
      ...styles,
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#6D7F92'
}),
    container: styles => ({
      ...styles,
      marginRight:'70px !important',
      marginLeft:'70px !important',
    }),

    valueContainer: styles => ({
      ...styles,
      height:'35px',
    }),

  })};


const textStyle = ()=> ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '16px',
  color: '#FFFFFF',
});


export const periodFilterStyle = () => {
  return({
    menu: styles => ({ ...styles,  zIndex: 3, backgroundColor: '#6D7F92', width:'85px'}),
    container: styles => ({ ...styles}),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: '#6D7F92',
      border: 'none',
      boxSizing: 'border-box',
      height:'32px',
      boxShadow: 'none',
      width: '83px',
      borderRadius: '30px',
    }),

    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : null
    }),

    valueContainer: styles => ({
      ...styles,
      height:'30px',
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...textStyle(),
      cursor: 'pointer',
      backgroundColor: isSelected && '#29394D' ,
      ':hover': {
        backgroundColor: '#D8DDE2',
      },
}),

    singleValue: styles => ({
      ...styles,
      ...textStyle(),
      marginLeft:'8px',
      textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',}),
  })};

const pageSizeTextStyle = ()=> ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '16px',
  color: '#3C4E64',
});


export const pageSizeFilterStyle = () => {
  return({
    menu: styles => ({ ...styles,  zIndex: 3, backgroundColor: '#F1F2F4', width:'85px'}),
    container: (styles, { isFocused, hasValue }) => ({
      ...styles,
      marginRight: '0 !important',
    }),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: '#F1F2F4',
      border: 'none',
      boxSizing: 'border-box',
      height:'32px',
      boxShadow: 'none',
      width: '83px',
      borderRadius: '30px',
    }),

    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : null
    }),

    valueContainer: styles => ({
      ...styles,
      height:'30px',
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...pageSizeTextStyle(),
      cursor: 'pointer',
      backgroundColor: isSelected && '#abb5bf' ,
      ':hover': {
        backgroundColor: '#F3FAFF',
      },
    }),

    singleValue: styles => ({
      ...styles,
      ...pageSizeTextStyle(),
      marginLeft:'8px',
    }),
  })};


export const budgetYearFilterStyle = () => {
  return({
    menu: styles => ({ ...styles,  zIndex: 3, backgroundColor: '#F1F2F4', width: '110px'}),
    container: (styles, { isFocused, hasValue }) => ({
      ...styles,
      marginRight: '0 !important',
    }),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: '#F1F2F4',
      border: 'none',
      boxSizing: 'border-box',
      height:'32px',
      boxShadow: 'none',
      width: '112px',
      borderRadius: '30px',
    }),

    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
    }),

    valueContainer: styles => ({
      ...styles,
      height:'30px',
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...pageSizeTextStyle(),
      cursor: 'pointer',
      backgroundColor: isSelected && '#abb5bf' ,
      ':hover': {
        backgroundColor: '#F3FAFF',
      },
    }),

    singleValue: styles => ({
      ...styles,
      ...pageSizeTextStyle(),
      marginLeft:'8px',
    }),
  })};


export const monthFilterStyle = () => {
  return({
    menu: styles => ({ ...styles,  zIndex: 3, backgroundColor: '#6D7F92', width:'130px'}),

    container: styles => ({ ...styles,  margin: '0 !important'}),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: '#FFFFFF',
      borderRadius: '0px',
      border: 'none',
      boxSizing: 'border-box',
      height:'25px',
      minHeight:'20px',
      boxShadow: 'none',
      width: '130px',
      borderBottom:'3px solid #29394D',
      ':hover': {
        borderBottom:'3px solid #29394D',
      },

    }),

    valueContainer: styles => ({
      ...styles,
      height:'18px',
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...textStyle(),
      cursor: 'pointer',
      backgroundColor: isSelected && '#29394D' ,
      ':hover': {
        backgroundColor: '#D8DDE2',
      },
    }),

    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : null
    }),

    singleValue: styles => ({
      ...styles,
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '16px',
      textTransform: 'capitalize',
      color: '#29394D',
      top:'50%'
  })})};

export const saisonFilterStyle = () => {
  return({
    menu: styles => ({ ...styles,  zIndex: 3, backgroundColor: '#6D7F92', width:'202px'}),

    container: styles => ({ ...styles,  marginRight: '0 !important', marginLeft:'0 !important'}),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor: '#6D7F92',
      border: 'none',
      boxSizing: 'border-box',
      height:'32px',
      boxShadow: 'none',
      width: '200px',
      borderRadius: '30px',
    }),

    valueContainer: styles => ({
      ...styles,
      height:'30px',
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...textStyle(),
      cursor: 'pointer',
      backgroundColor: isSelected && '#29394D' ,
      ':hover': {
        backgroundColor: '#D8DDE2',
      },
    }),

    singleValue: styles => ({
      ...styles,
      ...textStyle(),
      marginLeft:'8px',
      textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',}),
  })};

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const sendMessageFromIframe = (message, event) => {
  if (inIframe()) {
    const data = {
      message: message,
      event: event,
    };
    window.parent.postMessage(data, '*');
  }
}


export const newMangopayContactStyle = () => {
  return({
    menu: styles => ({ ...styles,  fontSize:'14px', color:'#29394d', }),
    control: styles => ({
      ...styles,
      border: "1px solid #B2BCC6",
      background: "#FFFFFF",
      boxSizing: 'border-box',
      borderRadius: '3px',
      boxShadow: 'none',
      height:'40px',
    }),
    input: styles => ({
      ...styles,
      fontSize:'14px',
      color:'#29394d',
      height:'40px',
      width: '0px !important',
      boxShadow:'none',
      border:'none',
    }),
    valueContainer: (styles, { isFocused, hasValue }) => ({
      ...styles,
      height:'35px',
    }),
  })};

export const actionsSelectStyle = () => {
  return({
    menu: styles => ({ ...styles, color:'#29394d', zIndex: 3,}),
    input: styles => ({
      ...styles,
      fontSize:'14px',
      color:'#29394d',
      height:'40px',
      width: '0px',
      boxShadow:'none',
      border:'none'
    }),
    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      backgroundColor:'#F8F9FA',
      border: 'none',
      borderBottom: '1px solid #B2BCC6',
      boxSizing: 'border-box',
      borderRadius: '3px',
      height:'40px',
      color:'#29394d',
      fontSize:'14px',
      boxShadow: 'none',
    }),
    placeholder: styles => ({
      ...styles,
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#6D7F92'
    }),
    container: styles => ({
      ...styles,
    }),

    valueContainer: styles => ({
      ...styles,
      height:'35px',
    }),


  })};

const headerFilterstextStyle = () => ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '16px',
  color: '#29394D',
});

const headerFilterStyle = () =>
  ({
    menu: styles => ({ ...styles,
      zIndex: 3,
      background:'#FFFFFF',
      border:'1px solid #18A0FB',
      borderRadius: '4px',
      width:'218px',
      top: 'auto',
    }),

    control: (styles, { isFocused, hasValue }) => ({
      ...styles,
      boxSizing: 'border-box',
      boxShadow: 'none',
      width: '218px',
      background:'#FFFFFF',
      border:'1px solid #18A0FB',
      borderRadius: '4px',
      minHeight:'34px',
      "&:hover": {
        background:'#FFFFFF',
        border:'1px solid #18A0FB',
        borderRadius: '4px',
      }
    }),

    option: (styles, { isDisabled, isSelected }) => ({
      ...styles,
      ...headerFilterstextStyle(),
      cursor: 'pointer',
      color : isSelected ? 'white' : '#29394D',
    }),
  })
;

export const yearsFilterStyle = () => {
  return({
    ...headerFilterStyle(),
    container: styles => ({ ...styles,  marginRight: '0px !important', marginLeft:'0 !important'}),

    multiValue: styles => ({
      ...styles,
      background:'#C7E8FE',
      borderRadius: '3px',
    }),

  })
};


export const newSeasonFilterStyle = () => {
  return({
    ...headerFilterStyle(),
    container: styles => ({ ...styles,  /*marginRight: '18px !important',*/ marginLeft:'0 !important'}),

    valueContainer: styles => ({
      ...styles,
      height:'32px',
    }),

    singleValue: styles => ({
      ...styles,
      ...headerFilterstextStyle(),
    }),

  })
};

export function formatNumber(number) {
  if(number < 10)
    return '0' + number;
  return new Intl.NumberFormat('fr-FR').format(number);
};


export function showErrorNotification(title, message) {
  notification['error']({
    message: title,
    description: message,
    style: {
      marginTop: 120,
    },
  });
};

export function showSuccessNotification(title, message) {
  notification['success']({
    message: title,
    description: message,
    style: {
      marginTop: 120,
    },
  });
};

export function formatPhoneNumber(number){
  if(number == null) {
    return " ";
  }
  if (number.substr(0, 3) == '+32') {

    let $base = number.substr(3);
    let $subStr = $base.substr(0, 2);


    if (['1', '5', '6', '7', '8'].includes($base.substr(0, 1))) {

      return '+32 (0)' + $subStr + ' ' + $base.substr(2, 2) + ' ' + $base.substr(4, 2) + ' ' + $base.substr( 6, 2);
    }

    if (['2', '3'].includes($base.substr(0, 1)) || ['42', '43', '90', '92', '93', '94', '97', '98', '99'].includes($subStr)) {

      return '+32 (0)' + $base.substr( 0, 1) + ' ' + $base.substr(1, 3) + ' ' + $base.substr( 4, 2) + ' ' + $base.substr( 6, 2);
    }

    if (['46', '47', '48', '49'].includes($subStr)) {

      return '+32 (0)'+ $base.substr(0, 3) + ' ' + $base.substr( 3, 2) + ' ' + $base.substr(5, 2) + ' ' + $base.substr(7, 2);
    }

    if ($base.substr( 0, 3) == '800'  || $subStr == '90') {

      return '+32 (0)' + $base.substr( 0, 3) + ' ' + $base.substr( 3, 2) + ' ' + $base.substr( 5, 3);
    }
  } else if (number.substr( 0, 3) == '+33') {
    let $base = number.substr(3);

    return  '+33 (0)' + $base.substr( 0, 1) + ' ' + $base.substr( 1, 2) + ' ' + $base.substr( 3, 2) + ' ' + $base.substr( 5, 2) + ' ' + $base.substr( 7, 2);
  }
  return number;
}

export function getYears() {
  let max = new Date().getFullYear()
  let years = []

  for (var i = max; i >= 2018; i--) {
    years.push(i + '')
  }
  return years
}

export function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}


export const initFromFilter = (group) => {
  const urlParams   = queryString.parse(location.search);

  if(!urlParams.filters) {
    return [];
  }

  let filter = urlFiltersParser(urlParams.filters);

  if(!filter || filter.length <= 0) {
    return [];
  }

  let appFilter = filter.filter(item => group === item.property);

  if (!appFilter || appFilter.length <= 0 || !appFilter[0].value) {
    return [];
  }
  return castArray(appFilter[0].value);
};

export function formatDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return date.toLocaleDateString('en-GB', options);
}

export function getBudgetManagementYears() {
  let max = new Date().getFullYear() + 1;
  let years = []

  for (var i = max; i >= 2018; i--) {
    years.push(i + '')
  }
  return years
}

export const formatCotisantDataWithStartEndMonth = (apiData, startMonth, endMonth) => {
    const result = {};
    // Parse YYYY-MM format safely
    const parseYM = (ym) => {
        const [year, month] = ym.split('-').map(Number);
        return new Date(year, month - 1, 1); // month is 0-indexed in Date
    };
    
    let current = parseYM(startMonth);
    const end = parseYM(endMonth);

    // Loop until we reach the end month
    while (current <= end) {
        const year = current.getFullYear();
        const month = (current.getMonth() + 1).toString().padStart(2, "0");
        const key = `${year}-${month}`;

        // insert data if exists, otherwise create empty record
        result[key] = apiData[key] || { 
            1: 0, 2: 0, 3: 0, 4: 0, 5: 0, ASSOCIATE: 0 
        };

        // increment by 1 month
        current.setMonth(current.getMonth() + 1);
    }

    return result;
};

export const formatCotisantData = (apiData, startMonth, endMonth, frequency) => {
      const categoryNames = {
        "1": "Profession économique (titrés et non titrés)",
        "2": "Sénior + Étudiants + Stagiaires",
        "3": "Stagiaires ITAA",
        "4": "Professions juridiques",
        "5": "Adhésion 2025",
        "ASSOCIATE": "Cotisation Associée",
      };
    
      let formatted = {
        totalCotisations: 0,
        categories: [
          { name: "Statutaire", color: "#007BFF", total: 0, subCategories: [] },
          { name: "Fiduciaire", color: "#FF6B00", total: 0, subCategories: [] },
        ],
      };

      const filteredApiData = frequency === "MONTHLY" ? formatCotisantDataWithStartEndMonth(apiData, startMonth, endMonth) : apiData;
    
      // Aggregate data
      Object.values(filteredApiData).forEach((monthData) => {        
        Object.entries(monthData).forEach(([key, value]) => {
          formatted.totalCotisations += value;
    
          if (key === "5") {
            // Fiduciaire Category
            formatted.categories[1].total += value;
            let subCategory = formatted.categories[1].subCategories.find((s) => s.name === categoryNames[key]);
    
            if (subCategory) {
              subCategory.count += value;
            } else {
              formatted.categories[1].subCategories.push({ name: categoryNames[key], count: value });
            }
          } else {
            // Statutaire Category
            formatted.categories[0].total += value;
            let subCategory = formatted.categories[0].subCategories.find((s) => s.name === categoryNames[key]);
    
            if (subCategory) {
              subCategory.count += value;
            } else {
              formatted.categories[0].subCategories.push({ name: categoryNames[key], count: value });
            }
          }
        });
      });
    
      return formatted;
    };


// WEBPACK FOOTER //
// ./app/services/utils.js